// https://dev.to/namirsab/comment/2050
const range = (start, end) => {
    const length = end - start + 1;
    return Array.from({ length }, (_, i) => start + i);
};
export function paginationLayout(pagination, config) {
    const { currentPage, totalPages } = pagination;
    const { boundaryCount = 1, siblingCount = 1 } = config;
    const startPages = range(1, Math.min(boundaryCount, totalPages));
    const endPages = range(Math.max(totalPages - boundaryCount + 1, boundaryCount + 1), totalPages);
    const siblingsStart = Math.max(Math.min(
    // Natural start
    currentPage - siblingCount, 
    // Lower boundary when page is high
    totalPages - boundaryCount - siblingCount * 2 - 1), 
    // Greater than startPages
    boundaryCount + 2);
    const siblingsEnd = Math.min(Math.max(
    // Natural end
    currentPage + siblingCount, 
    // Upper boundary when page is low
    boundaryCount + siblingCount * 2 + 2), 
    // Less than endPages
    endPages.length > 0 ? endPages[0] - 2 : totalPages - 1);
    // Basic list of items to render
    // e.g. itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']
    const itemList = [
        ...startPages,
        // Start ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...(siblingsStart > boundaryCount + 2
            ? ['start-ellipsis']
            : boundaryCount + 1 < totalPages - boundaryCount
                ? [boundaryCount + 1]
                : []),
        // Sibling pages
        ...range(siblingsStart, siblingsEnd),
        // End ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...(siblingsEnd < totalPages - boundaryCount - 1
            ? ['end-ellipsis']
            : totalPages - boundaryCount > boundaryCount
                ? [totalPages - boundaryCount]
                : []),
        ...endPages,
    ];
    // Map the button type to its page number
    // Convert the basic item list to PaginationItem props objects
    return itemList.map((item) => typeof item === 'number'
        ? {
            type: 'page',
            page: item,
        }
        : {
            type: item,
        });
}
